
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'

/**
 * 選択系モーダル
 */
@Component({
  components: {
    ModalWindow,
    ButtonSubmit,
    LabelBase,
  },
})
export default class SelectModal extends Vue {
  /** モーダル分子 */
  @Ref()
  private modalWindow!: ModalWindow

  /** 選択肢のコード一覧 */
  @Prop()
  private codeList!: string[]

  /** ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: () => void

  /** 選択中の項目コード */
  public currentItemCode: string = ''

  /** uuidの生成 */
  private readonly UUID: string = this.$getUUID()

  /**
   * 選択項目の識別IDを生成する
   *
   * @param code オプションのvalue
   * @returns UUIDとcodeで生成した識別ID
   */
  private makeItemId(code: string): string {
    return `${this.UUID}_${code}`
  }

  /**
   * モーダルを開く
   *
   * @param currentItemCode 選択中の値
   */
  public show(currentItemCode: string): void {
    this.currentItemCode = currentItemCode
    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }

  /**
   * ボタン押下時の処理
   */
  private submitEvent(): void {
    this.eventSubmit()
  }
}
